/* Boosh redesign script (v8 build). Behaviour for the boosh-* sections, ported
   from the approved draft cro/drafts/pdp-trimmer-23-09-2026/product-trimmer.html.

   Rules:
   - Each component initialises on its own element and guards everything it
     looks up; a missing element skips that component, never throws.
   - Components bind once per element (tracked on the element) and unbind on
     shopify:section:unload, so theme editor reloads never double-bind.
   - Plan state and the purchase live in Alpine (the section's Product()
     island). This file only talks to it through the bsh:plan:select event.
   - prefers-reduced-motion: no smooth scrolling. */
(function () {
  'use strict';
  if (window.BooshRedesign) return;

  var reduceMotion = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : { matches: false };
  function scrollBehavior() {
    return reduceMotion.matches ? 'auto' : 'smooth';
  }

  var registry = [];
  function register(name, selector, init) {
    registry.push({ name: name, selector: selector, init: init });
  }

  function on(cleanups, target, type, handler, options) {
    target.addEventListener(type, handler, options);
    cleanups.push(function () {
      target.removeEventListener(type, handler, options);
    });
  }

  function matchesIn(scope, selector) {
    var found = [];
    if (scope.nodeType === 1 && scope.matches && scope.matches(selector)) found.push(scope);
    if (scope.querySelectorAll) found = found.concat(Array.prototype.slice.call(scope.querySelectorAll(selector)));
    return found;
  }

  function bind(scope) {
    registry.forEach(function (component) {
      matchesIn(scope, component.selector).forEach(function (el) {
        el.__bshBound = el.__bshBound || {};
        if (el.__bshBound[component.name]) return;
        var cleanups = [];
        try {
          var extra = component.init(el, cleanups);
          if (typeof extra === 'function') cleanups.push(extra);
        } catch (err) {
          if (window.console) console.error('[boosh-redesign] ' + component.name, err);
        }
        el.__bshBound[component.name] = function () {
          cleanups.forEach(function (fn) {
            try { fn(); } catch (e) { /* element already gone */ }
          });
        };
      });
    });
  }

  function unbind(scope) {
    registry.forEach(function (component) {
      matchesIn(scope, component.selector).forEach(function (el) {
        if (el.__bshBound && el.__bshBound[component.name]) {
          el.__bshBound[component.name]();
          delete el.__bshBound[component.name];
        }
      });
    });
  }

  function sectionRoot(el) {
    return el.closest('[data-bsh-section]') || document;
  }

  function selectPlan(plan) {
    document.dispatchEvent(new CustomEvent('bsh:plan:select', { detail: { plan: plan } }));
  }

  /* Gallery: arrows, thumbnails, current thumb (draft script after </body>). */
  register('gallery', '[data-bsh-gallery]', function (wrap, off) {
    var g = wrap.querySelector('.bsh-buy__gallery');
    if (!g) return;
    var prev = wrap.querySelector('[data-bsh-gal="-1"]');
    var next = wrap.querySelector('[data-bsh-gal="1"]');
    function step() {
      var s = g.querySelector('.bsh-buy__shot');
      var gap = parseFloat(window.getComputedStyle(g).columnGap);
      return s ? s.getBoundingClientRect().width + (isNaN(gap) ? 12 : gap) : g.clientWidth;
    }
    function sync() {
      var h = step() / 2;
      if (prev) prev.hidden = g.scrollLeft < h;
      if (next) next.hidden = g.scrollLeft + g.clientWidth >= g.scrollWidth - h;
    }
    [prev, next].forEach(function (b) {
      if (!b) return;
      on(off, b, 'click', function () {
        g.scrollBy({ left: step() * parseInt(b.getAttribute('data-bsh-gal'), 10), behavior: scrollBehavior() });
      });
    });
    var tw = wrap.querySelector('[data-bsh-thumbs]');
    var shots = g.querySelectorAll('.bsh-buy__shot');
    var thumbs = [];
    if (tw) {
      tw.innerHTML = '';
      Array.prototype.forEach.call(shots, function (sh, i) {
        var im = sh.querySelector('img');
        var card = sh.classList.contains('bsh-icard');
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'bsh-gal-thumb';
        b.setAttribute('aria-label', 'Show photo ' + (i + 1) + ' of ' + shots.length);
        if (card) {
          var c = document.createElement('div');
          c.className = 'bsh-icard';
          c.setAttribute('aria-hidden', 'true');
          c.innerHTML = sh.innerHTML;
          Array.prototype.forEach.call(c.querySelectorAll('img'), function (x) { x.loading = 'lazy'; });
          b.appendChild(c);
        } else if (im) {
          var t = document.createElement('img');
          t.src = im.currentSrc || im.src;
          t.alt = '';
          t.loading = 'lazy';
          b.appendChild(t);
        } else {
          var ph = document.createElement('span');
          ph.className = 'bsh-ph';
          ph.setAttribute('aria-hidden', 'true');
          b.appendChild(ph);
        }
        if (sh.hasAttribute('data-bsh-gallery-video')) {
          b.classList.add('bsh-gal-thumb--video');
          b.setAttribute('aria-label', 'Show ' + sh.getAttribute('data-video-label') + ' video');
          var badge = document.createElement('span');
          badge.className = 'bsh-gallery-video__badge';
          badge.setAttribute('aria-hidden', 'true');
          badge.innerHTML = '<svg viewBox="0 0 24 24"><path d="m8 5 11 7-11 7Z" fill="currentColor"/></svg>';
          b.appendChild(badge);
        }
        on(off, b, 'click', function () {
          g.scrollTo({ left: i * step(), behavior: scrollBehavior() });
        });
        tw.appendChild(b);
        thumbs.push(b);
      });
      off.push(function () { tw.innerHTML = ''; });
    }
    var bar = wrap.querySelector('[data-bsh-gal-bar]');
    var count = wrap.querySelector('[data-bsh-gal-count]');
    if (bar && shots.length) bar.style.setProperty('--bsh-gal-w', (100 / shots.length) + '%');
    function current() {
      var i = Math.round(g.scrollLeft / step());
      thumbs.forEach(function (b, j) { b.setAttribute('aria-current', j === i ? 'true' : 'false'); });
      if (bar && shots.length > 1) {
        var room = g.scrollWidth - g.clientWidth;
        var p = room > 0 ? Math.min(Math.max(g.scrollLeft / room, 0), 1) : 0;
        bar.style.setProperty('--bsh-gal-x', (p * (shots.length - 1) * 100) + '%');
      }
      if (count && shots.length) count.textContent = Math.min(i + 1, shots.length) + ' / ' + shots.length;
      Array.prototype.forEach.call(shots, function (sh, j) {
        var video = sh.querySelector('[data-bsh-gallery-video] video, video[data-src]');
        if (video && j !== i && !video.paused) video.pause();
      });
    }
    on(off, g, 'scroll', function () { sync(); current(); }, { passive: true });
    on(off, window, 'resize', function () { sync(); current(); });
    sync();
    current();
  });

  /* Gallery expand: desktop with a fine pointer only (900px and up). Mobile
     taps do nothing. Close with the X, a click outside the slide, or Esc
     (native dialog). Videos keep their own controls and never expand. */
  register('gallery-zoom', '[data-bsh-gallery]', function (wrap, off) {
    var g = wrap.querySelector('.bsh-buy__gallery');
    if (!g || !window.matchMedia || typeof window.HTMLDialogElement !== 'function') return;
    var mq = window.matchMedia('(min-width: 900px) and (hover: hover) and (pointer: fine)');
    var shots = Array.prototype.filter.call(g.querySelectorAll('.bsh-buy__shot'), function (sh) {
      if (sh.hasAttribute('data-bsh-gallery-video')) return false;
      return sh.classList.contains('bsh-icard') || sh.classList.contains('bsh-statcard') || !!sh.querySelector('img');
    });
    if (!shots.length) return;
    var dlg = null;
    var body = null;
    var opener = null;

    function build() {
      dlg = document.createElement('dialog');
      dlg.className = 'bsh bsh-zoom';
      dlg.setAttribute('aria-label', 'Expanded photo');
      dlg.innerHTML = '<button type="button" class="bsh-zoom__close" aria-label="Close"><svg viewBox="0 0 24 24" aria-hidden="true" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="M6 6l12 12M18 6 6 18"/></svg></button><div class="bsh-zoom__body"></div>';
      body = dlg.querySelector('.bsh-zoom__body');
      dlg.querySelector('.bsh-zoom__close').addEventListener('click', function () { dlg.close(); });
      dlg.addEventListener('click', function (e) {
        if (e.target === dlg || e.target === body) dlg.close();
      });
      dlg.addEventListener('close', function () {
        body.innerHTML = '';
        document.documentElement.classList.remove('bsh-zoom-open');
        if (opener && opener.isConnected) opener.focus({ preventScroll: true });
        opener = null;
      });
      document.body.appendChild(dlg);
    }

    function open(sh) {
      if (!dlg) build();
      if (sh.classList.contains('bsh-icard') || sh.classList.contains('bsh-statcard')) {
        var c = sh.cloneNode(true);
        if (c.hasAttribute('data-bsh-zoom-role')) {
          c.removeAttribute('role');
          c.removeAttribute('aria-label');
        }
        ['tabindex', 'aria-haspopup', 'data-bsh-zoom-role'].forEach(function (a) { c.removeAttribute(a); });
        c.classList.remove('bsh-zoomable');
        Array.prototype.slice.call(c.attributes).forEach(function (a) {
          if (a.name.indexOf('data-shopify') === 0) c.removeAttribute(a.name);
        });
        Array.prototype.forEach.call(c.querySelectorAll('img'), function (x) {
          x.loading = 'eager';
          if (x.srcset) x.sizes = '800px';
        });
        body.appendChild(c);
      } else {
        var im = sh.querySelector('img');
        var big = document.createElement('img');
        big.className = 'bsh-zoom__photo';
        big.alt = im.alt || '';
        big.decoding = 'async';
        if (im.srcset) {
          big.sizes = '92vw';
          big.srcset = im.srcset;
        }
        big.src = im.currentSrc || im.src;
        body.appendChild(big);
      }
      opener = sh;
      document.documentElement.classList.add('bsh-zoom-open');
      dlg.showModal();
    }

    function sync() {
      shots.forEach(function (sh) {
        var photo = !sh.hasAttribute('role');
        if (mq.matches) {
          sh.classList.add('bsh-zoomable');
          sh.setAttribute('tabindex', '0');
          sh.setAttribute('aria-haspopup', 'dialog');
          if (photo || sh.hasAttribute('data-bsh-zoom-role')) {
            var im = sh.querySelector('img');
            sh.setAttribute('data-bsh-zoom-role', '');
            sh.setAttribute('role', 'button');
            sh.setAttribute('aria-label', 'Expand photo' + (im && im.alt ? ': ' + im.alt : ''));
          }
        } else {
          sh.classList.remove('bsh-zoomable');
          sh.removeAttribute('tabindex');
          sh.removeAttribute('aria-haspopup');
          if (sh.hasAttribute('data-bsh-zoom-role')) {
            sh.removeAttribute('data-bsh-zoom-role');
            sh.removeAttribute('role');
            sh.removeAttribute('aria-label');
          }
        }
      });
      if (!mq.matches && dlg && dlg.open) dlg.close();
    }

    on(off, g, 'click', function (e) {
      if (!mq.matches || e.target.closest('button, a, input, video')) return;
      var sh = e.target.closest('.bsh-buy__shot');
      if (sh && shots.indexOf(sh) > -1) open(sh);
    });
    on(off, g, 'keydown', function (e) {
      if (!mq.matches || (e.key !== 'Enter' && e.key !== ' ')) return;
      if (shots.indexOf(e.target) < 0) return;
      e.preventDefault();
      open(e.target);
    });
    if (mq.addEventListener) on(off, mq, 'change', sync);
    sync();
    off.push(function () {
      if (dlg) {
        if (dlg.open) dlg.close();
        dlg.remove();
        dlg = null;
      }
      shots.forEach(function (sh) {
        sh.classList.remove('bsh-zoomable');
        sh.removeAttribute('tabindex');
        sh.removeAttribute('aria-haspopup');
        if (sh.hasAttribute('data-bsh-zoom-role')) {
          sh.removeAttribute('data-bsh-zoom-role');
          sh.removeAttribute('role');
          sh.removeAttribute('aria-label');
        }
      });
    });
  });

  /* Gallery video: no media URL is attached until an explicit play action. */
  register('gallery-video', '[data-bsh-gallery-video]', function (wrap, off) {
    var video = wrap.querySelector('video');
    var start = wrap.querySelector('.bsh-gallery-video__start');
    var controls = wrap.querySelector('.bsh-gallery-video__controls');
    var toggle = wrap.querySelector('[data-video-toggle]');
    var seek = wrap.querySelector('[data-video-seek]');
    var sound = wrap.querySelector('[data-video-sound]');
    var error = wrap.querySelector('.bsh-gallery-video__error');
    var poster = wrap.querySelector('.bsh-gallery-video__poster');
    var label = wrap.getAttribute('data-video-label');
    if (!video || !start || !controls || !toggle || !seek || !sound) return;
    function format(value) {
      value = Math.max(0, Math.floor(value || 0));
      return Math.floor(value / 60) + ':' + ('0' + value % 60).slice(-2);
    }
    function update() {
      var duration = Number.isFinite(video.duration) ? video.duration : 0;
      seek.max = duration; seek.value = video.currentTime; seek.disabled = !duration;
      seek.setAttribute('aria-valuetext', format(video.currentTime) + ' of ' + format(duration));
      toggle.querySelector('[data-video-state]').textContent = video.paused ? 'Play' : 'Pause';
      toggle.querySelector('[data-video-icon]').textContent = video.paused ? '▶' : 'Ⅱ';
      toggle.setAttribute('aria-label', (video.paused ? 'Play ' : 'Pause ') + label);
      wrap.querySelector('[data-video-time]').textContent = format(video.currentTime) + ' / ' + format(duration);
      sound.setAttribute('aria-label', video.muted ? 'Unmute video' : 'Mute video');
      sound.querySelector('[data-video-muted]').toggleAttribute('hidden', !video.muted);
      sound.querySelector('[data-video-audible]').toggleAttribute('hidden', video.muted);
    }
    function failed() {
      start.hidden = false; controls.hidden = true; error.hidden = false;
      poster.hidden = false; video.controls = false;
    }
    function play() {
      error.hidden = true;
      if (!video.getAttribute('src') || video.error) {
        video.src = video.getAttribute('data-src'); video.load();
      }
      var promise = video.play();
      if (promise && promise.catch) promise.catch(failed);
    }
    on(off, start, 'click', play);
    on(off, toggle, 'click', function () { if (video.paused) play(); else video.pause(); });
    on(off, sound, 'click', function () { video.muted = !video.muted; });
    on(off, seek, 'input', function () { video.currentTime = Number(seek.value); });
    on(off, video, 'playing', function () {
      var focused = document.activeElement === start;
      start.hidden = true; controls.hidden = false; poster.hidden = true;
      if (focused) toggle.focus({ preventScroll: true });
      update();
    });
    on(off, video, 'ended', function () { start.hidden = false; controls.hidden = true; poster.hidden = false; });
    on(off, video, 'error', failed);
    ['loadedmetadata', 'timeupdate', 'play', 'pause', 'volumechange'].forEach(function (event) { on(off, video, event, update); });
    on(off, document, 'visibilitychange', function () { if (document.hidden) video.pause(); });
    off.push(function () { video.pause(); video.removeAttribute('src'); video.load(); });
    update();
  });

  /* "See all benefits" toggle on the refill option. */
  register('plan-toggle', '[data-bsh-plan-toggle]', function (toggle, off) {
    var opt = toggle.closest('.bsh-plan__opt') || sectionRoot(toggle);
    var more = opt.querySelector('[data-bsh-plan-more]');
    var details = opt.querySelector('[data-bsh-plan-sheet-open]');
    var label = toggle.querySelector('[data-bsh-plan-toggle-label]');
    on(off, toggle, 'click', function (e) {
      e.stopPropagation();
      var open = toggle.getAttribute('aria-expanded') !== 'true';
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (more) more.hidden = !open;
      if (details) details.hidden = !open;
      if (label) label.textContent = toggle.getAttribute(open ? 'data-label-open' : 'data-label-closed') || label.textContent;
    });
  });

  /* "How blade refills work" sheet: open, close, Escape, focus trap, focus return. */
  register('plan-sheet', '[data-bsh-plan-sheet]', function (sheet, off) {
    var root = sectionRoot(sheet);
    var panel = sheet.querySelector('.bsh-sheet__panel');
    var closeBtn = sheet.querySelector('.bsh-sheet__close');
    var lastFocus = null;
    var hideTimer = null;
    function isOpen() { return !sheet.hidden; }
    function open(e) {
      if (e) { e.preventDefault(); e.stopPropagation(); }
      clearTimeout(hideTimer);
      lastFocus = document.activeElement;
      sheet.hidden = false;
      requestAnimationFrame(function () { sheet.classList.add('is-open'); });
      document.documentElement.style.overflow = 'hidden';
      if (closeBtn) closeBtn.focus();
      sheet.dispatchEvent(new CustomEvent('bsh:sheet:open'));
    }
    function close() {
      if (!isOpen()) return;
      sheet.classList.remove('is-open');
      document.documentElement.style.overflow = '';
      hideTimer = setTimeout(function () { sheet.hidden = true; }, reduceMotion.matches ? 0 : 250);
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    }
    Array.prototype.forEach.call(root.querySelectorAll('[data-bsh-plan-sheet-open]'), function (b) {
      on(off, b, 'click', open);
    });
    Array.prototype.forEach.call(sheet.querySelectorAll('[data-bsh-plan-sheet-close]'), function (b) {
      on(off, b, 'click', close);
    });
    on(off, document, 'keydown', function (e) {
      if (!isOpen()) return;
      if (e.key === 'Escape') { close(); return; }
      if (e.key !== 'Tab' || !panel) return;
      var f = Array.prototype.filter.call(panel.querySelectorAll('button, a[href], [tabindex]:not([tabindex="-1"])'), function (el) {
        return el.offsetParent !== null && !el.disabled;
      });
      if (!f.length) return;
      var first = f[0];
      var last = f[f.length - 1];
      if (!sheet.contains(document.activeElement)) { e.preventDefault(); first.focus(); }
      else if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    });
    var choose = sheet.querySelector('[data-bsh-plan-sheet-choose]');
    if (choose) {
      on(off, choose, 'click', function () {
        selectPlan('subscribe');
        close();
      });
    }
    return function () {
      clearTimeout(hideTimer);
      if (isOpen()) document.documentElement.style.overflow = '';
    };
  });

  /* Perks row inside the sheet: arrows and mobile dots. */
  register('perks', '[data-bsh-perks]', function (row, off) {
    var scope = row.closest('.bsh-sheet') || sectionRoot(row);
    var btns = scope.querySelectorAll('[data-bsh-perks-nav]');
    var dots = scope.querySelector('.bsh-perks__dots');
    function card() { return row.querySelector('.bsh-perks__card'); }
    function step() { var c = card(); return c ? c.getBoundingClientRect().width + 10 : row.clientWidth; }
    function sync() {
      if (btns.length < 2) return;
      btns[0].disabled = row.scrollLeft < 4;
      btns[1].disabled = row.scrollLeft + row.clientWidth >= row.scrollWidth - 4;
    }
    function cols() {
      var c = row.querySelectorAll('.bsh-perks__card');
      return window.innerWidth < 600 ? Math.ceil(c.length / 2) : c.length;
    }
    function syncDots() {
      if (!dots || window.innerWidth >= 600 || !card()) return;
      var k = cols();
      if (dots.children.length !== k) {
        dots.innerHTML = '';
        for (var i = 0; i < k; i++) dots.appendChild(document.createElement('span'));
      }
      var w = card().getBoundingClientRect().width + 12;
      var at = row.scrollLeft + row.clientWidth >= row.scrollWidth - 4 ? k - 1 : Math.round(row.scrollLeft / w);
      Array.prototype.forEach.call(dots.children, function (d, i) { d.classList.toggle('is-on', i === at); });
    }
    Array.prototype.forEach.call(btns, function (b) {
      on(off, b, 'click', function () {
        row.scrollBy({ left: step() * parseInt(b.getAttribute('data-bsh-perks-nav'), 10), behavior: scrollBehavior() });
      });
    });
    on(off, row, 'scroll', function () { sync(); syncDots(); }, { passive: true });
    on(off, window, 'resize', function () { sync(); syncDots(); });
    on(off, scope, 'bsh:sheet:open', function () { setTimeout(function () { sync(); syncDots(); }, 50); });
    sync();
    syncDots();
  });

  /* Sticky buy bar: visible once the buy box button has scrolled away, hidden
     again when the footer arrives. The footer is optional. */
  register('buybar', '[data-bsh-buybar]', function (bar, off) {
    var root = sectionRoot(bar);
    var actions = root.querySelector('[data-bsh-buy-actions]');
    if (!actions) return;
    var visible = false;
    function footer() {
      return document.querySelector('.shopify-section-group-footer-group') || document.querySelector('footer');
    }
    function update() {
      var f = footer();
      var past = actions.getBoundingClientRect().bottom < 0;
      var beforeFooter = !f || f.getBoundingClientRect().top > window.innerHeight;
      var v = past && beforeFooter;
      if (v === visible) return;
      visible = v;
      bar.classList.toggle('is-visible', v);
      bar.setAttribute('aria-hidden', v ? 'false' : 'true');
      if (v) bar.removeAttribute('inert');
      else bar.setAttribute('inert', '');
    }
    on(off, window, 'scroll', update, { passive: true });
    on(off, window, 'resize', update);
    update();
  });

  /* Delivery estimate: business days from the dispatch timezone, cutoff hour
     and per-country day range carried on the element by Liquid. Sundays are
     skipped (as in the theme block); Saturdays when data-skip-saturday is true. */
  register('eta', '[data-bsh-eta]', function (el) {
    var min = parseInt(el.getAttribute('data-min'), 10);
    var max = parseInt(el.getAttribute('data-max'), 10);
    var cutoff = parseInt(el.getAttribute('data-cutoff'), 10);
    var tz = el.getAttribute('data-tz') || undefined;
    var skipSat = el.getAttribute('data-skip-saturday') === 'true';
    if (isNaN(min) || isNaN(max)) return;
    if (max < min) max = min;
    var parts;
    try {
      parts = new Intl.DateTimeFormat('en-NZ', { timeZone: tz, year: 'numeric', month: 'numeric', day: 'numeric', hour: 'numeric', hourCycle: 'h23' }).formatToParts(new Date());
    } catch (e) {
      parts = new Intl.DateTimeFormat('en-NZ', { year: 'numeric', month: 'numeric', day: 'numeric', hour: 'numeric', hourCycle: 'h23' }).formatToParts(new Date());
    }
    var p = {};
    parts.forEach(function (x) { p[x.type] = parseInt(x.value, 10); });
    var day = new Date(Date.UTC(p.year, p.month - 1, p.day));
    function off(d) { var w = d.getUTCDay(); return w === 0 || (skipSat && w === 6); }
    function addDay(d) { return new Date(d.getTime() + 86400000); }
    if (!isNaN(cutoff) && p.hour >= cutoff) day = addDay(day);
    while (off(day)) day = addDay(day);
    var count = 0;
    var start = null;
    var end = null;
    var d = day;
    for (var i = 0; i < 40 && !end; i++) {
      d = addDay(d);
      if (off(d)) continue;
      count++;
      if (count === min) start = d;
      if (count === max) end = d;
    }
    if (!start || !end) return;
    var f = { weekday: 'short', day: 'numeric', month: 'short', timeZone: 'UTC' };
    el.textContent = start.toLocaleDateString('en-NZ', f) + ' to ' + end.toLocaleDateString('en-NZ', f);
  });

  /* Reviews link: the draft points at #reviews (boosh-pdp-reviews). Without
     that section on the page, fall back to the Judge.me widget. */
  register('reviews-link', '[data-bsh-reviews-link]', function (a) {
    if (document.getElementById('reviews')) return;
    var jm = document.getElementById('judgeme_product_reviews') || document.querySelector('.jdgm-widget.jdgm-review-widget');
    if (!jm) return;
    if (!jm.id) jm.id = 'judgeme_product_reviews';
    a.setAttribute('href', '#' + jm.id);
  });

  /* ---- Slice 2: trimmer PDP sections below the buy box. ---- */

  /* Scroll reveals (draft "Scroll reveals"): each [data-bsh-reveal] gets .is-in
     once on screen and its [data-bsh-count] numbers count up. Reduced motion or
     no IntersectionObserver: shown at once, numbers stay as printed. */
  function revealStill() {
    return reduceMotion.matches || !('IntersectionObserver' in window);
  }
  function countUp(el) {
    var n = parseFloat(el.getAttribute('data-bsh-count'));
    if (isNaN(n)) return;
    var suf = el.getAttribute('data-bsh-suffix') || '';
    var t0 = null;
    if (getComputedStyle(el).display !== 'block') el.style.minWidth = el.getBoundingClientRect().width + 'px';
    function step(t) {
      if (!t0) t0 = t;
      var k = Math.min((t - t0) / 1400, 1);
      var e = 1 - Math.pow(1 - k, 3);
      el.textContent = Math.round(n * e).toLocaleString('en-NZ') + (k === 1 ? suf : '');
      if (k < 1) requestAnimationFrame(step);
    }
    requestAnimationFrame(step);
  }
  register('reveal', '[data-bsh-reveal]', function (el) {
    if (el.hasAttribute('data-bsh-stagger')) {
      Array.prototype.forEach.call(el.children, function (c, i) { c.style.setProperty('--i', i); });
    }
    if (revealStill()) {
      el.classList.add('is-in');
      return;
    }
    document.documentElement.classList.add('bsh-reveal-ready');
    if (el.classList.contains('is-in')) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        el.classList.add('is-in');
        Array.prototype.forEach.call(el.querySelectorAll('[data-bsh-count]'), countUp);
        io.disconnect();
      });
    }, { threshold: 0.25 });
    io.observe(el);
    return function () { io.disconnect(); };
  });

  /* Heads: tapping a row swaps the photo and the caption (draft "heads"). */
  register('heads', '[data-bsh-heads]', function (root, off) {
    var rows = root.querySelectorAll('[data-bsh-head]');
    var photos = root.querySelectorAll('[data-bsh-photo]');
    var title = root.querySelector('p[data-bsh-caption-title]');
    var text = root.querySelector('p[data-bsh-caption-text]');
    function pick(row) {
      var key = row.getAttribute('data-bsh-head');
      Array.prototype.forEach.call(rows, function (r) {
        var on = r === row;
        r.classList.toggle('is-active', on);
        r.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      Array.prototype.forEach.call(photos, function (p) {
        p.classList.toggle('is-active', p.getAttribute('data-bsh-photo') === key);
      });
      if (title) title.textContent = row.getAttribute('data-bsh-caption-title') || '';
      if (text) text.textContent = row.getAttribute('data-bsh-caption-text') || '';
    }
    Array.prototype.forEach.call(rows, function (r) {
      on(off, r, 'click', function () { pick(r); });
    });
  });

  /* "As easy as": the three words highlight in turn; still for reduced motion. */
  register('easy', '[data-bsh-easy]', function (easy) {
    if (reduceMotion.matches) return;
    var words = easy.querySelectorAll('.bsh-easy__word');
    if (words.length < 2) return;
    var i = 0;
    Array.prototype.forEach.call(words, function (w, j) { if (w.classList.contains('is-on')) i = j; });
    var timer = setInterval(function () {
      words[i].classList.remove('is-on');
      i = (i + 1) % words.length;
      words[i].classList.add('is-on');
    }, 2200);
    return function () { clearInterval(timer); };
  });

  /* Comparison pills: swap the right-hand column (scoped to its section). */
  register('compare', '[data-bsh-compare]', function (root, off) {
    var btns = root.querySelectorAll('[data-bsh-cmp]');
    var head = root.querySelector('[data-bsh-cmp-head]');
    Array.prototype.forEach.call(btns, function (b) {
      on(off, b, 'click', function () {
        var k = b.getAttribute('data-bsh-cmp');
        Array.prototype.forEach.call(btns, function (x) {
          x.classList.toggle('is-on', x === b);
          x.setAttribute('aria-pressed', x === b ? 'true' : 'false');
        });
        if (head) head.textContent = b.textContent;
        Array.prototype.forEach.call(root.querySelectorAll('.bsh-compare__them[data-' + k + ']'), function (c) {
          c.textContent = c.getAttribute('data-' + k);
        });
      });
    });
  });

  /* "What to expect": the line fills with scroll; full for reduced motion. */
  register('timeline', '[data-tl-scroll]', function (tl, off) {
    var stops = Array.prototype.slice.call(tl.querySelectorAll('.bsh-tl__stop'));
    if (stops.length < 2) return;
    var first = 0;
    var last = 0;
    var ys = [];
    function measure() {
      var r = tl.getBoundingClientRect();
      ys = stops.map(function (s) {
        var d = s.querySelector('.bsh-tl__dot');
        if (!d) return 0;
        var b = d.getBoundingClientRect();
        return b.top + b.height / 2 - r.top;
      });
      first = ys[0];
      last = ys[ys.length - 1];
      tl.style.setProperty('--tl-top', first + 'px');
      tl.style.setProperty('--tl-end', (r.height - last) + 'px');
    }
    function update() {
      var r = tl.getBoundingClientRect();
      var at = window.innerHeight * 0.6 - r.top;
      var span = last - first;
      var p = reduceMotion.matches || span <= 0 ? 1 : Math.max(0, Math.min(1, (at - first) / span));
      tl.style.setProperty('--p', p);
      stops.forEach(function (s, i) { s.classList.toggle('is-on', reduceMotion.matches || at >= ys[i] - 2); });
    }
    function refresh() { measure(); update(); }
    refresh();
    on(off, window, 'scroll', update, { passive: true });
    on(off, window, 'resize', refresh);
    on(off, window, 'load', refresh);
  });

  /* "Choose blade refills" (cost section): the page-level click handler below
     selects refills. With #buy on the page it scrolls there without changing
     the hash (a hashchange would re-read a ?plan= already in the URL and undo
     the choice). Without #buy the link goes to the trimmer PDP. */
  register('choose-refills', '[data-bsh-choose-refills]', function (a, off) {
    if (!document.getElementById('buy')) {
      var url = a.getAttribute('data-bsh-refills-url');
      if (url) a.setAttribute('href', url);
      return;
    }
    on(off, a, 'click', function (e) {
      var buy = document.getElementById('buy');
      if (!buy) return;
      e.preventDefault();
      buy.scrollIntoView({ behavior: scrollBehavior(), block: 'start' });
    });
  });

  /* "Read all reviews": scroll to the Judge.me widget further down the page. */
  register('reviews-all', '[data-bsh-reviews-all]', function (a, off) {
    function target() {
      return document.getElementById('judgeme_product_reviews') ||
        document.querySelector('.jdgm-review-widget, .jdgm-widget.jdgm-review-widget');
    }
    on(off, a, 'click', function (e) {
      var t = target();
      if (!t) return;
      e.preventDefault();
      var sec = t.closest('.shopify-section') || t;
      sec.scrollIntoView({ behavior: scrollBehavior(), block: 'start' });
    });
  });

  /* Spare blades: one-time add through the theme cart. One POST to
     cart/add.js with the cart drawer sections, then the theme's own
     shapes:cart:afteradditem event refreshes (and, per theme setting, opens)
     the drawer, as the product form does. Cart type "page": native submit. */
  register('spare', '[data-bsh-spare-form]', function (form, off) {
    var busy = false;
    on(off, form, 'submit', function (e) {
      var theme = window.theme || {};
      var modal = theme.settings && theme.settings.cartType === 'modal';
      var addUrl = theme.routes && theme.routes.cart_add_url;
      if (!modal || !addUrl || !window.fetch) return;
      e.preventDefault();
      if (busy) return;
      busy = true;
      var button = form.querySelector('button[type="submit"]');
      var error = form.querySelector('.bsh-oneoff__error');
      if (error) { error.hidden = true; error.textContent = ''; }
      if (button) { button.disabled = true; button.setAttribute('aria-busy', 'true'); }
      var data = new FormData(form);
      data.delete('selling_plan');
      data.set('sections', 'cart-items,cart-footer,cart-item-count,cart-live-region');
      data.set('sections_url', window.location.pathname);
      fetch(addUrl + '.js', {
        method: 'POST',
        headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: data
      }).then(function (res) {
        return res.json().then(function (json) { return { ok: res.ok, json: json }; });
      }).then(function (r) {
        if (!r.ok || r.json.status) {
          var msg = r.json.description || r.json.message || (theme.strings && theme.strings.cartError) || 'Something went wrong.';
          throw new Error(msg);
        }
        document.body.dispatchEvent(new CustomEvent('shapes:cart:afteradditem', {
          bubbles: true,
          detail: { response: r.json, sourceId: form.id, originalTarget: button }
        }));
      }).catch(function (err) {
        if (error) {
          error.textContent = (err && err.message) || (theme.strings && theme.strings.cartError) || 'Something went wrong.';
          error.hidden = false;
        }
      }).then(function () {
        busy = false;
        if (button) { button.disabled = false; button.removeAttribute('aria-busy'); }
      });
    });
  });

  /* Page-level, bound once: any [data-bsh-choose-refills] link selects the
     refill plan (plus its own navigation), and #buy?plan=refills scrolls to #buy. */
  document.addEventListener('click', function (e) {
    var a = e.target.closest ? e.target.closest('[data-bsh-choose-refills], [data-bsh-pick-refills]') : null;
    if (a) selectPlan('subscribe');
  });

  function scrollToBuyFromHash() {
    if (!/^#buy[?&]/.test(window.location.hash)) return;
    var buy = document.getElementById('buy');
    if (buy) buy.scrollIntoView({ behavior: 'auto', block: 'start' });
  }

  function start() {
    bind(document);
    scrollToBuyFromHash();
  }

  document.addEventListener('shopify:section:load', function (e) { bind(e.target); });
  document.addEventListener('shopify:section:unload', function (e) { unbind(e.target); });
  window.addEventListener('hashchange', scrollToBuyFromHash);

  window.BooshRedesign = { bind: bind, unbind: unbind, selectPlan: selectPlan };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
